const config = [
  { propName: 'reviews', reducerName: 'reviews' },
  { propName: 'navigationReviews', reducerName: 'navigationReviews' },
  { propName: 'filters', reducerName: 'filters' },
  { propName: 'sort', reducerName: 'sort' },
  { propName: 'searchTerm', reducerName: 'searchTerm' },
  { propName: 'page', reducerName: 'page' },
  { propName: 'pagination', reducerName: 'pagination' },
  { propName: 'reviewersList', reducerName: 'reviewersList' },
  { propName: 'requestersList', reducerName: 'requestersList' },
  { propName: 'statusFilter', reducerName: 'statusFilter' },
  {
    propName: 'projectsByActiveReviews',
    reducerName: 'projectsByActiveReviews',
  },
  { propName: 'reviewMetrics', reducerName: 'reviewMetrics' },
];

// Function to dynamically generate project details
export const getReviews = (state) => {
  const reviews = {};

  config.forEach(({ propName, reducerName }) => {
    reviews[propName] = state?.reviews?.[reducerName];
  });

  return reviews;
};
